export default __webpack_public_path__ + "static/Live-It-Up-In-Style-2e8fec86643f34b4ff7a0e1969616b23.jpg";